import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import Immutable from 'immutable';

const ENV_DEV = process.env.NODE_ENV === 'development';

export function wrapReact(Component, name, conf = { intl: true }) {
  if (ENV_DEV && !name) {
    console.log(
      '%c%s%s',
      'color:blue',
      'Component name missing: ',
      Component.name,
    );
  }

  let NewComponent;
  if (Component.prototype && Component.prototype.hasOwnProperty('render')) {
    const oldRender = Component.prototype.render;
    NewComponent = Component;
    NewComponent.prototype.render = function render(...args) {
      try {
        if (ENV_DEV) console.log('%c%s%s', 'color:green', 'Render: ', name);
        return oldRender.apply(this, args);
      } catch (e) {
        if (ENV_DEV) console.log('%c%s%s', 'color:red', `${name} `, e);
        return <div> err page </div>;
      }
    };

    NewComponent.prototype.shouldComponentUpdate = function f(
      inProps,
      inState,
    ) {
      const thisProps = this.props || {};
      const thisState = this.state || {};
      const nextState = inProps || {};
      const nextProps = inState || {};

      if (
        Object.keys(thisProps).length !== Object.keys(nextProps).length
        || Object.keys(thisState).length !== Object.keys(nextState).length
      ) {
        return true;
      }

      for (const key in nextProps) {
        if (!Immutable.is(thisProps[key], nextProps[key])) {
          if (
            typeof thisProps[key] !== 'function'
            || thisProps[key].toString() !== nextProps[key].toString()
          ) {
            return true;
          }
        }
      }

      for (const key in nextState) {
        if (!Immutable.is(thisState[key], nextState[key])) {
          return true;
        }
      }
      return false;
    };
  } else {
    NewComponent = function f(props) {
      try {
        if (ENV_DEV) console.log('%c%s%s', 'color:green', 'Render: ', name);
        return Component(props);
      } catch (e) {
        if (ENV_DEV) console.log('%c%s%s', 'color:red', `${name} `, e);
        return <div> err page </div>;
      }
    };
  }
  NewComponent.propTypes = {
    className: PropTypes.string,
    filePath: PropTypes.string.isRequired,
    ...Component.propTypes,
  };
  NewComponent.defaultProps = {
    className: '',
    filePath: name,
    ...Component.defaultProps,
  };
  return conf.intl ? injectIntl(NewComponent) : NewComponent;
}

export default wrapReact;
